module.exports = " <button class=d-btn-upload type=button _v-588a8e0a=\"\"> <slot _v-588a8e0a=\"\"></slot> <input type=file @change=onchange($event) _v-588a8e0a=\"\"> </button> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-588a8e0a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Upload.vue
 ** module id = 675
 ** module chunks = 2
 **/